(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmReferralSourceTypeSearch', CrmReferralSourceTypeSearch);

    CrmReferralSourceTypeSearch.$inject = ['$resource'];

    function CrmReferralSourceTypeSearch($resource) {
        var resourceUrl =  'api/_search/crm-referral-source-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
